import { render, staticRenderFns } from "./TestServiceTerms.vue?vue&type=template&id=33947aea&"
import script from "./TestServiceTerms.vue?vue&type=script&lang=js&"
export * from "./TestServiceTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports